// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mali-rapor-container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    margin: 0;
    padding: 20px;
    background-color: #eef1f5;
    color: #333;
    line-height: 1.6;
    min-height: 100vh;
}

.dark-theme .mali-rapor-container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    margin: 0;
    padding: 20px;
    background-color: #1a1a1a;
    color: #333;
    line-height: 1.6;
    min-height: 100vh;
}

.mali-rapor-content {
    background-color: #ffffff;
    padding: 30px 40px;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
    max-width: 1000px;
    margin: 20px auto;
}

.dark-theme .mali-rapor-content {
    background-color: #1a1a1a;
    color: #151414;
}

.mali-rapor-content .main-title {
    color: #0056b3;
    text-align: center;
    margin-bottom: 10px;
    font-size: 2.2em;
    font-weight: 600;
}

.mali-rapor-content .lokasyon-adi {
    color: #4a5568;
    text-align: center;
    margin-bottom: 35px;
    font-size: 1.3em;
    font-weight: 500;
}

.year-selector {
    margin-bottom: 30px;
    text-align: center;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 10px;
    border: 1px solid #e0e5ec;
}

.dark-theme .year-selector {
    background-color: #1a1a1a;
    border-color: #303030;
}

.year-selector label {
    display: block;
    margin-bottom: 10px;
}

.prediction-info {
    margin-top: 15px;
    padding: 10px;
    background-color: #1a1a1a;
    border-radius: 6px;
}

.dark-theme .prediction-info {
    margin-top: 15px;
    padding: 10px;
    background-color: #1a1a1a;
    border-radius: 6px;
}

.prediction-info small {
    font-size: 0.9em;
    color: #1565c0;
    font-weight: 500;
}

.prediction-badge {
    display: inline-block;
    padding: 4px 8px;
    background-color: #d5d2cc;
    color: white;
    border-radius: 4px;
    font-size: 0.8em;
    font-weight: bold;
    margin-left: 8px;
}

.section {
    margin-bottom: 40px;
    padding: 25px;
    border-radius: 10px;
    border: 1px solid #e0e5ec;
}

.dark-theme .section {
    margin-bottom: 40px;
    padding: 25px;
    background-color: #1a1a1a;
    border-radius: 10px;
    border: 1px solid #303030;  
}
.section .ant-card-head {
    background-color: transparent;
    border-bottom: 2px solid #b8d7fa;
    padding-bottom: 12px;
}

.section .ant-card-head-title {
    color: #007bff;
    font-size: 1.6em;
    font-weight: 500;
}

.profitability-section {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;
}

.profitability-section .ant-card-head-title {
    color: #0050b3;
    border-bottom-color: #69c0ff;
}

.details-condensed {
    list-style: none;
    padding-left: 0;
}

.details-condensed p {
    margin: 5px 0;
    font-size: 0.95em;
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid #e9edf2;
}

.details-condensed p:last-child {
    border-bottom: none;
}

.details-condensed strong {
    color: #333;
    margin-right: 8px;
}

.details-condensed span {
    font-weight: 500;
    color: #007bff;
    text-align: right;
}

.summary-value {
    font-size: 1.1em;
    font-weight: 600;
}

.summary-value.positive {
    color: #27ae60;
}

.summary-value.negative {
    color: #e74c3c;
}

span.summary-value {
    background-color: #ffffff;
    font-weight: 900 !important;
    padding: 2px 6px;
    border-radius: 5px;
}

.ant-table-tbody > tr > td {
    border: 1px solid #d1d9e6;
    padding: 10px 12px;
}

.ant-table-thead > tr > th {
    background-color: #e2e8f0;
    color: #2d3748;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border: 1px solid #d1d9e6;
    padding: 10px 12px;
}

.ant-table-tbody > tr:nth-child(even) > td {
    background-color: #f7fafc;
}

.ant-table-summary {
    background-color: #cbd5e0 !important;
}

.ant-table-summary td {
    font-weight: bold;
    background-color: #cbd5e0 !important;
    color: #1a202c;
    font-size: 1em;
}

#yearlyProfitSection .ant-card-head {
    background-color: #f3e5f5;
    border-bottom: 2px solid #9c27b0;
}

#yearlyProfitSection .ant-card-head-title {
    color: #9c27b0;
}

#yearlyProfitSection .ant-table-thead > tr > th {
    background-color: #9c27b0;
    color: white;
    text-align: center;
}

`, "",{"version":3,"sources":["webpack://./src/components/harita/pages/MaliRaporPage.css"],"names":[],"mappings":"AAAA;IACI,4DAA4D;IAC5D,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,4DAA4D;IAC5D,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".mali-rapor-container {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    margin: 0;\n    padding: 20px;\n    background-color: #eef1f5;\n    color: #333;\n    line-height: 1.6;\n    min-height: 100vh;\n}\n\n.dark-theme .mali-rapor-container {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    margin: 0;\n    padding: 20px;\n    background-color: #1a1a1a;\n    color: #333;\n    line-height: 1.6;\n    min-height: 100vh;\n}\n\n.mali-rapor-content {\n    background-color: #ffffff;\n    padding: 30px 40px;\n    border-radius: 12px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n    max-width: 1000px;\n    margin: 20px auto;\n}\n\n.dark-theme .mali-rapor-content {\n    background-color: #1a1a1a;\n    color: #151414;\n}\n\n.mali-rapor-content .main-title {\n    color: #0056b3;\n    text-align: center;\n    margin-bottom: 10px;\n    font-size: 2.2em;\n    font-weight: 600;\n}\n\n.mali-rapor-content .lokasyon-adi {\n    color: #4a5568;\n    text-align: center;\n    margin-bottom: 35px;\n    font-size: 1.3em;\n    font-weight: 500;\n}\n\n.year-selector {\n    margin-bottom: 30px;\n    text-align: center;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 10px;\n    border: 1px solid #e0e5ec;\n}\n\n.dark-theme .year-selector {\n    background-color: #1a1a1a;\n    border-color: #303030;\n}\n\n.year-selector label {\n    display: block;\n    margin-bottom: 10px;\n}\n\n.prediction-info {\n    margin-top: 15px;\n    padding: 10px;\n    background-color: #1a1a1a;\n    border-radius: 6px;\n}\n\n.dark-theme .prediction-info {\n    margin-top: 15px;\n    padding: 10px;\n    background-color: #1a1a1a;\n    border-radius: 6px;\n}\n\n.prediction-info small {\n    font-size: 0.9em;\n    color: #1565c0;\n    font-weight: 500;\n}\n\n.prediction-badge {\n    display: inline-block;\n    padding: 4px 8px;\n    background-color: #d5d2cc;\n    color: white;\n    border-radius: 4px;\n    font-size: 0.8em;\n    font-weight: bold;\n    margin-left: 8px;\n}\n\n.section {\n    margin-bottom: 40px;\n    padding: 25px;\n    border-radius: 10px;\n    border: 1px solid #e0e5ec;\n}\n\n.dark-theme .section {\n    margin-bottom: 40px;\n    padding: 25px;\n    background-color: #1a1a1a;\n    border-radius: 10px;\n    border: 1px solid #303030;  \n}\n.section .ant-card-head {\n    background-color: transparent;\n    border-bottom: 2px solid #b8d7fa;\n    padding-bottom: 12px;\n}\n\n.section .ant-card-head-title {\n    color: #007bff;\n    font-size: 1.6em;\n    font-weight: 500;\n}\n\n.profitability-section {\n    background-color: #e6f7ff;\n    border: 1px solid #91d5ff;\n}\n\n.profitability-section .ant-card-head-title {\n    color: #0050b3;\n    border-bottom-color: #69c0ff;\n}\n\n.details-condensed {\n    list-style: none;\n    padding-left: 0;\n}\n\n.details-condensed p {\n    margin: 5px 0;\n    font-size: 0.95em;\n    display: flex;\n    justify-content: space-between;\n    padding: 6px 0;\n    border-bottom: 1px solid #e9edf2;\n}\n\n.details-condensed p:last-child {\n    border-bottom: none;\n}\n\n.details-condensed strong {\n    color: #333;\n    margin-right: 8px;\n}\n\n.details-condensed span {\n    font-weight: 500;\n    color: #007bff;\n    text-align: right;\n}\n\n.summary-value {\n    font-size: 1.1em;\n    font-weight: 600;\n}\n\n.summary-value.positive {\n    color: #27ae60;\n}\n\n.summary-value.negative {\n    color: #e74c3c;\n}\n\nspan.summary-value {\n    background-color: #ffffff;\n    font-weight: 900 !important;\n    padding: 2px 6px;\n    border-radius: 5px;\n}\n\n.ant-table-tbody > tr > td {\n    border: 1px solid #d1d9e6;\n    padding: 10px 12px;\n}\n\n.ant-table-thead > tr > th {\n    background-color: #e2e8f0;\n    color: #2d3748;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    border: 1px solid #d1d9e6;\n    padding: 10px 12px;\n}\n\n.ant-table-tbody > tr:nth-child(even) > td {\n    background-color: #f7fafc;\n}\n\n.ant-table-summary {\n    background-color: #cbd5e0 !important;\n}\n\n.ant-table-summary td {\n    font-weight: bold;\n    background-color: #cbd5e0 !important;\n    color: #1a202c;\n    font-size: 1em;\n}\n\n#yearlyProfitSection .ant-card-head {\n    background-color: #f3e5f5;\n    border-bottom: 2px solid #9c27b0;\n}\n\n#yearlyProfitSection .ant-card-head-title {\n    color: #9c27b0;\n}\n\n#yearlyProfitSection .ant-table-thead > tr > th {\n    background-color: #9c27b0;\n    color: white;\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
